import { createSelector } from "reselect";
import { RootState } from "../reducers";
import { EditFeature } from "./types";

const getEditFeatureState = ({ editFeature }) => editFeature;

export const canUndoEditFeature = createSelector(getEditFeatureState, editFeature => editFeature?.past.length > 0);

export const canRedoEditFeature = createSelector(getEditFeatureState, editFeature => editFeature?.future.length > 0);

export const getFirstPastEditFeature = createSelector(getEditFeatureState, editFeature => editFeature?.past[0]);

export const getCurrentEditFeature = ({ editFeature }: RootState): EditFeature => {
  return (
    editFeature.present || {
      attributes: [],
      geometry: [],
    }
  );
};

export const getCurrentAttributes = createSelector(getCurrentEditFeature, feature => feature.attributes);
